import { loadLanguageAsync } from '@/i18n-setup';
import { ApiService } from '@/services/api.service';

export default {
  state: {
    languages: [
      { code: 'en', name: 'English' },
      { code: 'fr', name: 'French' },
    ],
    selectedLanguage: null,
  },
  actions: {
    updateLanguage: ({ state, commit }, { code }) => {
      loadLanguageAsync(code).then(() => {
        const option = state.languages.find((l) => l.code === code);
        commit('SET_LANGUAGE', option);
      });
    },
    updateLanguages: ({ commit }, newLanguages) => {
      commit('UPDATE_LANGUAGES', newLanguages);
    },
  },

  mutations: {
    SET_LANGUAGE: (state, lang) => {
      state.selectedLanguage = lang;
      localStorage.setItem('stellantis-language', lang.code);
      ApiService.setLang(lang.code);
      document.location.reload();
    },
    UPDATE_LANGUAGES: (state, data) => {
      if (data) {
        state.languages = data;
      }
    },
  },
};
